import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  withWritedlio9p0oewet as withWrite,
  invoke1ju2p3vzzanvk as invoke,
} from '../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  MonetaryValue__div_impl_3meibk3mb2kbjjy06qs as MonetaryValue__div_impl_3meibk,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from '../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { coerceAtMostfyc3emgaderp as coerceAtMost } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { take9j4462mea726 as take } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  Icon1h1pe6893iwt2 as Icon,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  get_empty2lwyggrwaqgos as get_empty,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  get_state389x218zizu8a as get_state,
  beginUse146s8dwmfk72s as beginUse,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  Reactive1jy75v4li6ldv as Reactive,
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  set1ugseoes1jrmg as set,
  ReactiveWithMutableValue1h1r6ig7acce5 as ReactiveWithMutableValue,
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set_0,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens_1,
  lens26es9640ifscs as lens_2,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { LimitReadable2ecfn2s8p9gvk as LimitReadable } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/deprecated.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  coroutineScope284yy3flyb2v2 as coroutineScope,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { filterNotNullhujglslymx1l as filterNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import {
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  chunked1umgsyuj0x9u1 as chunked,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { IndexedValue22atz80p92rrf as IndexedValue } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/IndexedValue.mjs';
import { lens27v59dqa1oc3r as lens_3 } from '../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { DragShadow11keb9piinnfw as DragShadow } from '../../../../kiteui-library/com/lightningkite/kiteui/models/DragData.mjs';
import { get_viewIsWide3s4g60a9e0192 as get_viewIsWide } from '../views/components/nav/crowpay.mjs';
import {
  Companion_instance2rgq1hlpwff0j as Companion_instance_0,
  Platform_Web_getInstanceu4ctcncq1n0 as Platform_Web_getInstance,
} from '../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { get_waitForNotNull2non1pqjf7sqr as get_waitForNotNull } from '../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var lowercaseBoundary;
var loremIpsum;
function containsDynamic(_this__u8e3s4, value) {
  _init_properties_utils_kt__i7zv1b();
  var tmp = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.baj(_this__u8e3s4);
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = value($this$remember);
    return tmp.t1(tmp$ret$0);
  });
  return withWrite(tmp, containsDynamic$slambda_0(_this__u8e3s4, value));
}
function percentComplete(workCompleted, price) {
  _init_properties_utils_kt__i7zv1b();
  return MonetaryValue__compareTo_impl_w7ul1r(price, Companion_instance.o62(0)) <= 0 ? 0.0 : coerceAtMost(MonetaryValue__div_impl_3meibk(workCompleted, price), 1.0);
}
function renderPercent(_this__u8e3s4, precision) {
  precision = precision === VOID ? 2 : precision;
  _init_properties_utils_kt__i7zv1b();
  // Inline function 'kotlin.run' call
  var $this$run = (_this__u8e3s4 * 100).toString();
  var pre = substringBefore($this$run, _Char___init__impl__6a9atx(46));
  var post = take(substringAfter($this$run, _Char___init__impl__6a9atx(46), ''), precision);
  var tmp;
  var tmp_0;
  // Inline function 'kotlin.text.isNotBlank' call
  if (!isBlank(post)) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.text.all' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(post)) {
        var element = charSequenceGet(post, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (!(element === _Char___init__impl__6a9atx(48))) {
          tmp$ret$2 = false;
          break $l$block;
        }
      }
      tmp$ret$2 = true;
    }
    tmp_0 = !tmp$ret$2;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = pre + '.' + post + '%';
  } else {
    tmp = pre + '%';
  }
  return tmp;
}
function get_money(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  return new (Icon())(get_rem(2), get_rem(2), 0, -960, 960, 960, listOf('M444-200h70v-50q50-9 86-39t36-89q0-42-24-77t-96-61q-60-20-83-35t-23-41q0-26 18.5-41t53.5-15q32 0 50 15.5t26 38.5l64-26q-11-35-40.5-61T516-710v-50h-70v50q-50 11-78 44t-28 74q0 47 27.5 76t86.5 50q63 23 87.5 41t24.5 47q0 33-23.5 48.5T486-314q-33 0-58.5-20.5T390-396l-66 26q14 48 43.5 77.5T444-252v52Zm36 120q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z'));
}
function lazy(_this__u8e3s4, readable, render) {
  _init_properties_utils_kt__i7zv1b();
  reactiveScope(_this__u8e3s4, ($this$reactiveScope) => {
    var item = $this$reactiveScope.baj(readable);
    _this__u8e3s4.zb9();
    render(_this__u8e3s4, item);
    return Unit_instance;
  });
}
function shownDefaultFalse(_this__u8e3s4, action) {
  _init_properties_utils_kt__i7zv1b();
  _this__u8e3s4.hb7(false);
  var tmp = KMutableProperty0();
  var tmp_0 = RView$_get_shown_$ref_1dlfeq(_this__u8e3s4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, RView$_set_shown_$ref_rx90zu(_this__u8e3s4));
  var actionToCalculate = action;
  reactiveScope(_this__u8e3s4, ($this$reactiveScope) => {
    this_0.set(actionToCalculate($this$reactiveScope));
    return Unit_instance;
  });
}
function share(_this__u8e3s4, action) {
  _init_properties_utils_kt__i7zv1b();
  return remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return action($this$remember, $this$remember.baj(_this__u8e3s4));
  });
}
function Action_0(name, frequencyCap, action) {
  var tmp;
  if (frequencyCap === VOID) {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance_0();
    tmp = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
  } else {
    tmp = frequencyCap;
  }
  frequencyCap = tmp;
  _init_properties_utils_kt__i7zv1b();
  var tmp0_icon = get_empty(Companion_getInstance());
  return Action(name, tmp0_icon, VOID, VOID, frequencyCap, VOID, action);
}
function zeroToNull(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  var tmp = zeroToNull$lambda;
  return _this__u8e3s4.tak(tmp, zeroToNull$lambda_0);
}
function zeroToNull_0(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  var tmp = zeroToNull$lambda_1;
  return _this__u8e3s4.tak(tmp, zeroToNull$lambda_2);
}
function nullableToBlank(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  var tmp = nullableToBlank$lambda;
  return _this__u8e3s4.tak(tmp, nullableToBlank$lambda_0);
}
function equalToDynamic(_this__u8e3s4, value) {
  _init_properties_utils_kt__i7zv1b();
  var tmp = rememberSuspending(VOID, VOID, VOID, equalToDynamic$slambda_0(_this__u8e3s4, value));
  return withWrite(tmp, equalToDynamic$slambda_2(_this__u8e3s4, value));
}
function iconAndAction(_this__u8e3s4, icon_0, title, action) {
  _init_properties_utils_kt__i7zv1b();
  _this__u8e3s4.jbb(get_centered(_this__u8e3s4), icon(_this__u8e3s4, icon_0, title));
  _this__u8e3s4.mbg(Action(title, icon_0, VOID, VOID, VOID, VOID, action));
}
function get_notNull(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  return new (notNull$1())(_this__u8e3s4);
}
function goBackOrReplaceWith(_this__u8e3s4, page) {
  _init_properties_utils_kt__i7zv1b();
  if (!_this__u8e3s4.qd6()) {
    _this__u8e3s4.nd6(page());
  }
}
function resize(_this__u8e3s4, size) {
  _init_properties_utils_kt__i7zv1b();
  return _this__u8e3s4.gd5(size, size);
}
function flatLens(_this__u8e3s4, getWrite) {
  _init_properties_utils_kt__i7zv1b();
  var tmp = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(getWrite($this$remember.baj(_this__u8e3s4))));
  return withWrite(tmp, flatLens$slambda_0(getWrite, _this__u8e3s4));
}
function flatten(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  var tmp = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(_this__u8e3s4)));
  return withWrite(tmp, flatten$slambda_0(_this__u8e3s4));
}
function awaitSuspending(_this__u8e3s4, $completion) {
  return await_0(_this__u8e3s4, $completion);
}
function navigateTo(_this__u8e3s4, to) {
  _init_properties_utils_kt__i7zv1b();
  return _this__u8e3s4.dbw(to);
}
function ConstantLimitReadable$Companion$NOOP$lambda() {
  return Unit_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        tmp.og6_1 = ConstantLimitReadable$Companion$NOOP$lambda;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion())();
  return Companion_instance_1;
}
var ConstantLimitReadableClass;
function ConstantLimitReadable() {
  if (ConstantLimitReadableClass === VOID) {
    class $ {
      constructor(value, limit) {
        Companion_getInstance_1();
        limit = limit === VOID ? 50 : limit;
        this.pg6_1 = value;
        this.qg6_1 = limit;
      }
      f2() {
        return this.pg6_1;
      }
      oe1(_set____db54di) {
        this.qg6_1 = _set____db54di;
      }
      pe1() {
        return this.qg6_1;
      }
      tah(listener) {
        return Companion_getInstance_1().og6_1;
      }
    }
    protoOf($).qah = get_state;
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'ConstantLimitReadable', VOID, VOID, [LimitReadable(), ReactiveValue()]);
    ConstantLimitReadableClass = $;
  }
  return ConstantLimitReadableClass;
}
function containsAny(_this__u8e3s4, elements) {
  _init_properties_utils_kt__i7zv1b();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(_this__u8e3s4, Collection())) {
      tmp = _this__u8e3s4.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = _this__u8e3s4.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (elements.t1(element)) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function getMany(_this__u8e3s4, keys) {
  _init_properties_utils_kt__i7zv1b();
  var values = ArrayList().w();
  var _iterator__ex2g4s = keys.m1();
  while (_iterator__ex2g4s.n1()) {
    var key = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver = _this__u8e3s4.p3(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      values.v(tmp0_safe_receiver);
    }
  }
  return values;
}
function *_generator_forEachAsync__i5apka(_this__u8e3s4, threads, action, $completion) {
  var tmp = coroutineScope(forEachAsync$slambda_0(_this__u8e3s4, threads, action), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function forEachAsync(_this__u8e3s4, threads, action, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_forEachAsync__i5apka.bind(VOID, _this__u8e3s4, threads, action), $completion);
}
function maxOfNotNullOrNull(items) {
  _init_properties_utils_kt__i7zv1b();
  return maxOrNull(filterNotNull(items));
}
function truncate(_this__u8e3s4, n) {
  _init_properties_utils_kt__i7zv1b();
  return _this__u8e3s4.length > n ? take(_this__u8e3s4, n) + '...' : _this__u8e3s4;
}
function withReverseIndex(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(_this__u8e3s4, 10));
  var index = 0;
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var idx = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$0 = new (IndexedValue())((_this__u8e3s4.p1() - idx | 0) - 1 | 0, item);
    destination.v(tmp$ret$0);
  }
  return destination;
}
function filter(_this__u8e3s4, predicate) {
  _init_properties_utils_kt__i7zv1b();
  return remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(_this__u8e3s4);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      if (predicate($this$remember, element)) {
        destination.v(element);
      }
    }
    return destination;
  });
}
function lensFilter(_this__u8e3s4, predicate) {
  _init_properties_utils_kt__i7zv1b();
  return lens_3(_this__u8e3s4, (it) => {
    // Inline function 'kotlin.collections.filter' call
    var predicate_0 = predicate;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = it.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (predicate_0(element)) {
        destination.v(element);
      }
    }
    return destination;
  });
}
function round(_this__u8e3s4, decimals) {
  _init_properties_utils_kt__i7zv1b();
  // Inline function 'kotlin.math.pow' call
  var factor = Math.pow(10.0, decimals);
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = _this__u8e3s4 * factor;
  return roundToInt(this_0) / factor;
}
function filterNullKeys(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  var map = LinkedHashMap().fc(_this__u8e3s4.p1());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.d2().m1();
  while (_iterator__ex2g4s.n1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.o1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.e2();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.f2();
    if (!(key == null)) {
      // Inline function 'kotlin.collections.set' call
      map.s3(key, value);
    }
  }
  return map;
}
function DragShadow_0(view, xAlign, yAlign, xOffset, yOffset) {
  xAlign = xAlign === VOID ? Align_Center_getInstance() : xAlign;
  yAlign = yAlign === VOID ? Align_Center_getInstance() : yAlign;
  xOffset = xOffset === VOID ? null : xOffset;
  yOffset = yOffset === VOID ? null : yOffset;
  _init_properties_utils_kt__i7zv1b();
  return view == null ? null : new (DragShadow())(view, xAlign, yAlign, xOffset, yOffset);
}
function interceptImmediateWrite(_this__u8e3s4, action) {
  _init_properties_utils_kt__i7zv1b();
  return new (interceptImmediateWrite$2())(_this__u8e3s4, action);
}
function html(_this__u8e3s4, content) {
  _init_properties_utils_kt__i7zv1b();
  reactive(_this__u8e3s4, ($this$reactive) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = content($this$reactive);
    _this__u8e3s4.acp(tmp$ret$0);
    return Unit_instance;
  });
}
function interceptValueSet(_this__u8e3s4, interceptor) {
  _init_properties_utils_kt__i7zv1b();
  return new (interceptValueSet$1())(_this__u8e3s4, interceptor);
}
function isUsingKeyboard(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  return get_viewIsWide(_this__u8e3s4) && get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
function *_generator_invoke__zhh2q8($this, $this$withWrite, contains, $completion) {
  if (contains) {
    var tmp = invoke($this.sg6_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.rg6_1.lam(tmp);
  } else {
    var tmp_0 = invoke($this.sg6_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.rg6_1.kam(tmp_0);
  }
  return Unit_instance;
}
var containsDynamic$slambdaClass;
function containsDynamic$slambda() {
  if (containsDynamic$slambdaClass === VOID) {
    class $ {
      constructor($this_containsDynamic, $value) {
        this.rg6_1 = $this_containsDynamic;
        this.sg6_1 = $value;
      }
      afz($this$withWrite, contains, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withWrite, contains), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    containsDynamic$slambdaClass = $;
  }
  return containsDynamic$slambdaClass;
}
function containsDynamic$slambda_0($this_containsDynamic, $value) {
  var i = new (containsDynamic$slambda())($this_containsDynamic, $value);
  var l = ($this$withWrite, contains, $completion) => i.afz($this$withWrite, contains, $completion);
  l.$arity = 2;
  return l;
}
function RView$_get_shown_$ref_1dlfeq(p0) {
  return () => p0.wb8();
}
function RView$_set_shown_$ref_rx90zu(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function zeroToNull$lambda(it) {
  _init_properties_utils_kt__i7zv1b();
  var tmp = it;
  var tmp0_elvis_lhs = tmp == null ? null : tmp.a5s_1;
  var tmp_0;
  var tmp_1 = tmp0_elvis_lhs;
  if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
    tmp_0 = Companion_instance.p91(0n);
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return new (MonetaryValue())(tmp_0);
}
function zeroToNull$lambda_0(it) {
  _init_properties_utils_kt__i7zv1b();
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!(it.a5s_1 === Companion_instance.p91(0n))) {
    tmp = it;
  } else {
    tmp = null;
  }
  var tmp_0 = tmp;
  var tmp_1 = tmp_0 == null ? null : tmp_0.a5s_1;
  return tmp_1 == null ? null : new (MonetaryValue())(tmp_1);
}
function zeroToNull$lambda_1(it) {
  _init_properties_utils_kt__i7zv1b();
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!(it === 0)) {
    tmp = it;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver;
}
function zeroToNull$lambda_2(it) {
  _init_properties_utils_kt__i7zv1b();
  var tmp1_elvis_lhs = it == null ? null : numberToInt(it);
  return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
}
function nullableToBlank$lambda(it) {
  _init_properties_utils_kt__i7zv1b();
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!(it == null)) {
    tmp = it;
  } else {
    tmp = null;
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function nullableToBlank$lambda_0(it) {
  _init_properties_utils_kt__i7zv1b();
  return it;
}
function *_generator_invoke__zhh2q8_0($this, $this$rememberSuspending, $completion) {
  var tmp = await_0($this.tg6_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.ug6_1($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return equals(tmp, tmp_0);
}
var equalToDynamic$slambdaClass;
function equalToDynamic$slambda() {
  if (equalToDynamic$slambdaClass === VOID) {
    class $ {
      constructor($this_equalToDynamic, $value) {
        this.tg6_1 = $this_equalToDynamic;
        this.ug6_1 = $value;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    equalToDynamic$slambdaClass = $;
  }
  return equalToDynamic$slambdaClass;
}
function equalToDynamic$slambda_0($this_equalToDynamic, $value) {
  var i = new (equalToDynamic$slambda())($this_equalToDynamic, $value);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$withWrite, it, $completion) {
  if (it) {
    var tmp = $this.wg6_1($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = $this.vg6_1.gah(tmp, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var equalToDynamic$slambdaClass_0;
function equalToDynamic$slambda_1() {
  if (equalToDynamic$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_equalToDynamic, $value) {
        this.vg6_1 = $this_equalToDynamic;
        this.wg6_1 = $value;
      }
      afz($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    equalToDynamic$slambdaClass_0 = $;
  }
  return equalToDynamic$slambdaClass_0;
}
function equalToDynamic$slambda_2($this_equalToDynamic, $value) {
  var i = new (equalToDynamic$slambda_1())($this_equalToDynamic, $value);
  var l = ($this$withWrite, it, $completion) => i.afz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
var notNull$1Class;
function notNull$1() {
  if (notNull$1Class === VOID) {
    class $ {
      constructor($this_notNull) {
        this.yg6_1 = $this_notNull;
        this.xg6_1 = get_waitForNotNull($this_notNull);
      }
      waq(value, $completion) {
        return this.yg6_1.gah(value, $completion);
      }
      gah(value, $completion) {
        return this.waq(!(value == null) ? value : THROW_CCE(), $completion);
      }
      qah() {
        return this.xg6_1.qah();
      }
      tah(listener) {
        return this.xg6_1.tah(listener);
      }
      iaj() {
        return this.xg6_1.iaj();
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactive(), Reactive()], [1]);
    notNull$1Class = $;
  }
  return notNull$1Class;
}
function *_generator_invoke__zhh2q8_2($this, $this$withWrite, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ag7_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.zg6_1(tmp$ret$0).gah(it, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var flatLens$slambdaClass;
function flatLens$slambda() {
  if (flatLens$slambdaClass === VOID) {
    class $ {
      constructor($getWrite, $this_flatLens) {
        this.zg6_1 = $getWrite;
        this.ag7_1 = $this_flatLens;
      }
      rar($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.rar(tmp, (p2 == null ? true : !(p2 == null)) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    flatLens$slambdaClass = $;
  }
  return flatLens$slambdaClass;
}
function flatLens$slambda_0($getWrite, $this_flatLens) {
  var i = new (flatLens$slambda())($getWrite, $this_flatLens);
  var l = ($this$withWrite, it, $completion) => i.rar($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$withWrite, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bg7_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.gah(it, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var flatten$slambdaClass;
function flatten$slambda() {
  if (flatten$slambdaClass === VOID) {
    class $ {
      constructor($this_flatten) {
        this.bg7_1 = $this_flatten;
      }
      rar($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.rar(tmp, (p2 == null ? true : !(p2 == null)) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    flatten$slambdaClass = $;
  }
  return flatten$slambdaClass;
}
function flatten$slambda_0($this_flatten) {
  var i = new (flatten$slambda())($this_flatten);
  var l = ($this$withWrite, it, $completion) => i.rar($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $this$launch, $completion) {
  var _iterator__ex2g4s = $this.cg7_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp = $this.dg7_1($this.eg7_1, element, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var forEachAsync$slambda$slambdaClass;
function forEachAsync$slambda$slambda() {
  if (forEachAsync$slambda$slambdaClass === VOID) {
    class $ {
      constructor($group, $action, $this_coroutineScope) {
        this.cg7_1 = $group;
        this.dg7_1 = $action;
        this.eg7_1 = $this_coroutineScope;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    forEachAsync$slambda$slambdaClass = $;
  }
  return forEachAsync$slambda$slambdaClass;
}
function forEachAsync$slambda$slambda_0($group, $action, $this_coroutineScope) {
  var i = new (forEachAsync$slambda$slambda())($group, $action, $this_coroutineScope);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var forEachAsync$slambdaClass;
function forEachAsync$slambda() {
  if (forEachAsync$slambdaClass === VOID) {
    class $ {
      constructor($this_forEachAsync, $threads, $action) {
        this.fg7_1 = $this_forEachAsync;
        this.gg7_1 = $threads;
        this.hg7_1 = $action;
      }
      wah($this$coroutineScope, $completion) {
        // Inline function 'kotlin.math.ceil' call
        var x = this.fg7_1.p1() / this.gg7_1;
        var tmp$ret$0 = Math.ceil(x);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = chunked(this.fg7_1, numberToInt(tmp$ret$0)).m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          launch($this$coroutineScope, VOID, VOID, forEachAsync$slambda$slambda_0(element, this.hg7_1, $this$coroutineScope));
        }
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    forEachAsync$slambdaClass = $;
  }
  return forEachAsync$slambdaClass;
}
function forEachAsync$slambda_0($this_forEachAsync, $threads, $action) {
  var i = new (forEachAsync$slambda())($this_forEachAsync, $threads, $action);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var interceptImmediateWrite$2Class;
function interceptImmediateWrite$2() {
  if (interceptImmediateWrite$2Class === VOID) {
    class $ {
      constructor($this_interceptImmediateWrite, $action) {
        this.jg7_1 = $this_interceptImmediateWrite;
        this.kg7_1 = $action;
        this.ig7_1 = $this_interceptImmediateWrite;
      }
      cak(value) {
        return this.kg7_1(this.jg7_1, value);
      }
      qah() {
        return this.ig7_1.qah();
      }
      tah(listener) {
        return this.ig7_1.tah(listener);
      }
      iaj() {
        return this.ig7_1.iaj();
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    protoOf($).gah = set;
    initMetadataForClass($, VOID, VOID, VOID, [ReactiveWithMutableValue(), Reactive()], [1]);
    interceptImmediateWrite$2Class = $;
  }
  return interceptImmediateWrite$2Class;
}
var interceptValueSet$1Class;
function interceptValueSet$1() {
  if (interceptValueSet$1Class === VOID) {
    class $ {
      constructor($this_interceptValueSet, $interceptor) {
        this.mg7_1 = $this_interceptValueSet;
        this.ng7_1 = $interceptor;
        this.lg7_1 = $this_interceptValueSet;
      }
      mam(value) {
        this.ng7_1(this.mg7_1, value);
      }
      f2() {
        return this.mg7_1.f2();
      }
      nam(thisRef, property) {
        return this.mg7_1.f2();
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qah() {
        return this.lg7_1.qah();
      }
      tah(listener) {
        return this.lg7_1.tah(listener);
      }
      iaj() {
        return this.lg7_1.iaj();
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).cak = valueSet;
    protoOf($).gah = set_0;
    protoOf($).pam = setValue;
    protoOf($).tak = lens_1;
    protoOf($).bak = lens_2;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue(), ReactiveValue()], [1]);
    interceptValueSet$1Class = $;
  }
  return interceptValueSet$1Class;
}
var properties_initialized_utils_kt_wt0odb;
function _init_properties_utils_kt__i7zv1b() {
  if (!properties_initialized_utils_kt_wt0odb) {
    properties_initialized_utils_kt_wt0odb = true;
    lowercaseBoundary = Regex().qh('\\b[a-z]');
    loremIpsum = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
  }
}
//region block: exports
export {
  Action_0 as Action1a4ymn5nx79hk,
  ConstantLimitReadable as ConstantLimitReadable29q2jwoe6byet,
  DragShadow_0 as DragShadowu6jlihuvhlhp,
  containsAny as containsAny27n115ngkvovr,
  containsDynamic as containsDynamic2tw0myh68yr3u,
  equalToDynamic as equalToDynamic3go34vx15ysu8,
  filterNullKeys as filterNullKeys1r8wmaox0efdd,
  filter as filter31kgiqs90is7g,
  flatLens as flatLens32lsgpliumxw4,
  flatten as flatten286v3fmuz892n,
  getMany as getMany3bs02247im3ra,
  goBackOrReplaceWith as goBackOrReplaceWith1hxiq2flhlluq,
  html as html1nvxkcfsy8qu3,
  iconAndAction as iconAndAction2wga7n7i065rc,
  interceptImmediateWrite as interceptImmediateWrite9xa8d51e8bew,
  interceptValueSet as interceptValueSet2j91wmwtts8v0,
  isUsingKeyboard as isUsingKeyboard18gbvw16gm0yg,
  lazy as lazygopf2ohairjp,
  lensFilter as lensFilter5xvs6ea8thrl,
  maxOfNotNullOrNull as maxOfNotNullOrNull2k16vysnptiyz,
  get_money as get_money1hho0fu3wco2x,
  navigateTo as navigateTo251lpwmg2lk0y,
  get_notNull as get_notNull33xpghyvur0tf,
  nullableToBlank as nullableToBlankejlkf60pbnzu,
  percentComplete as percentComplete22ixcedvdan2,
  renderPercent as renderPercent3ullukkakwyrl,
  resize as resize3py5p2yrjp6p7,
  round as round3rel4gzky0cf0,
  share as share11y1uwr9hp0zm,
  shownDefaultFalse as shownDefaultFalse3hpz4awymyomc,
  truncate as truncate3gvhc1a2is66m,
  withReverseIndex as withReverseIndex2csyfnzqm7ypp,
  zeroToNull as zeroToNull11q39tqjxlqyg,
  zeroToNull_0 as zeroToNulldfpl77mwwdjq,
  awaitSuspending as awaitSuspendingfmims6z9kmaq,
  forEachAsync as forEachAsync1pu32d5cchlqb,
};
//endregion

//# sourceMappingURL=utils.mjs.map
